import { render, staticRenderFns } from "./cashRegister.vue?vue&type=template&id=6f89ce20"
import script from "./cashRegister.vue?vue&type=script&lang=js"
export * from "./cashRegister.vue?vue&type=script&lang=js"
import style0 from "./cashRegister.vue?vue&type=style&index=0&id=6f89ce20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports